module.exports = __webpack_public_path__ + "197a2d6f6cdaa1149609095f6357d293.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/luxury-apartments-empty.png
// module id = 315
// module chunks = 0